import { render, staticRenderFns } from "./PaginationNav.vue?vue&type=template&id=4edd5a16&scoped=true&"
import script from "./PaginationNav.vue?vue&type=script&lang=js&"
export * from "./PaginationNav.vue?vue&type=script&lang=js&"
import style0 from "./PaginationNav.vue?vue&type=style&index=0&id=4edd5a16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd5a16",
  null
  
)

export default component.exports